import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { memo, useEffect, useRef } from 'react';
import { ReactBabylonLink, SceneNamesToFileName } from '.';
const SceneFrame = ({ currentScene, hidden, children }) => {
    const frameRef = useRef(null);
    useEffect(() => {
        if (frameRef.current) {
            ReactBabylonLink.FrameRef = frameRef.current;
        }
        return () => {
            ReactBabylonLink.FrameRef = null;
        };
    }, []);
    const width = '100%';
    const height = '100%';
    // dynamic CSS for the lft and right arrow
    const iframeProps = {
        id: 'sceneFrame',
        ref: frameRef,
        width,
        height,
        scrolling: 'no',
        frameBorder: '0',
        title: currentScene,
        src: `/babylon/engine.html?scene=${SceneNamesToFileName.get(currentScene)}.gltf`
    };
    return (_jsxs(_Fragment, { children: [_jsx("iframe", Object.assign({}, iframeProps, { style: { display: 'block', pointerEvents: 'all' } })), children] }));
};
export default memo(SceneFrame);
